import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'

let getRepeatHtml = (tag, texts, config) => {
  let res = ""
  for(let i = 0; i < texts.length; i++){
    res += `<${tag}`
    if(config.props) {
      for(let k in config.props){
        res += ` ${k}=${config.props[k]}`
      }
    }
    res += `>${texts[i] || ""}</${tag}>`
    if(config.br){
      res += `<br />`
    }
  }
  return res
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '编程学习'
    },
  },
  {
    path: '/code',
    name: 'code',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CodeView.vue'),
    meta: {
      title: '编程语言'
    },
    children: store.state.tabs.map(code=>{
      return {
        path: code.type,
        name: 'Code' + code.type,
        component: {
          template: `<el-container>
            <el-header>
              <h2>${code.label}简介</h2>
            </el-header>
            <el-main style="margin:0.5em auto;max-width:1200px;text-align:left;text-indent:2em;">
              ${getRepeatHtml('p', code.html.history, {br: 1})}
            </el-main>
            <el-footer>
              <el-link type="info" target="_blank" href="${code.html.editor}">${code.label}在线编辑器</el-link>
            </el-footer>
          </el-container>`
        },
        meta: {
          title: code.label + ' - 编程语言'
        }
      }
    })
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: {
      title: '零零幺二幺零'
    }
  },
  {
    path: '/essay',
    name: 'essay',
    component: () => import('../views/EssayView.vue'),
    meta: {
      title: '零零幺二幺零'
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: '关于'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
})

export default router
